module.exports = __webpack_public_path__ + "img/1024.728e6fca.svg";